<template>
  <div class="columns mgt-20px is-multiline">
    <div class="column is-6">
      <div class="card">
        <header class="header-card">
          <p>
            {{$t('societes.infoSociete')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-3">
              <figure class="media-left">
                <app-logo></app-logo>
              </figure>
            </div>
            <div class="column">
              <div class="columns">
                <div class="column">
                  <b-field :label="$t('societes.codeSociete')" class="obligatoire">
                    <b-input v-model="societe.codeSociete"></b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field :label="$t('societes.typeSociete')" class="obligatoire">
                    <b-select v-model="societe.typeSociete" expanded>
                      <option v-for="item in listeSociete"
                        :key="item.code"
                        :value="item.code">
                        {{$t(item.libelle)}}
                      </option>
                    </b-select>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column is-12">
                  <b-field :label="$t('societes.libelle')" class="obligatoire">
                    <b-input v-model="societe.libelle"></b-input>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-6">
              <b-field :label="$t('societes.email')">
                <b-input v-model="societe.emailPrincipal"></b-input>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.tel')">
                <b-input v-model="societe.telephone"></b-input>
              </b-field>
            </div>
          </div>
          <div class="">
            <div class="">
              <b-field :label="$t('societes.fax')">
                <b-input v-model="societe.fax"></b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column is-6">
      <div class="card height-100">
        <header class="header-card">
          <p>
            {{$t('societes.adresseSociete')}}
          </p>
        </header>
        <div class="card-content">
          <b-field :label="$t('societes.adressePost')"></b-field>
          <app-adresse :adresse="societe.adresse" :afficherIntitule='false'
                       :tableName="SOCIETE"></app-adresse>
        </div>
      </div>
    </div>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{$t('societes.infoComp')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-2">
              <b-field :label="$t('societes.codeAPE')">
                <b-input v-model="societe.codeAPE"></b-input>
              </b-field>
            </div>
            <div class="column is-2">
              <b-field :label="$t('societes.siret')">
                <b-input v-model="societe.siret"></b-input>
              </b-field>
            </div>
            <div class="column is-2">
              <b-field :label="$t('societes.juridique')">
                <b-input v-model="societe.structureJuridique"></b-input>
              </b-field>
            </div>
            <div class="column is-2">
              <b-field :label="$t('societes.tribunal')">
                <b-input v-model="societe.tribunal"></b-input>
              </b-field>
            </div>
            <div class="column is-2">
              <b-field :label="$t('societes.numeroEmetteur')">
                <b-input v-model="societe.numeroEmetteur" type="number"></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-4 societes">
              <b-field :label="$t('societes.tva')">
                <b-input v-model="societe.tvaIntracommunautaire"></b-input>
              </b-field>
              <b-field :label="$t('societes.regimeTva')">
                <b-select v-model="societe.regimeTvaId">
                  <option></option>
                  <option v-for='tva in listeRegimeTva(societe.regimeTvaId)'
                          :key="tva.id"
                          :value="tva.id">
                    {{ tva.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-8 societes">
              <b-field :label='$t("societes.commentaireFactureIntracommunautaire")'>
                <qd-text-editor v-model="societe.commentaireFactureIntracommunautaire">
                </qd-text-editor>
              </b-field>
            </div>
          </div>
          <div class="columns is-multiline">
            <div class="column is-4 societes">
              <b-field :label="$t('societes.adresseLivraison')">
                <b-input v-model="societe.adresseLivraison" type="textarea"></b-input>
              </b-field>
            </div>
            <div class="column is-8 societes">
              <b-field :label='$t("societes.signatureEmail")'>
                <qd-text-editor v-model="societe.emailSignature" :height="125" />
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{$t('societes.produitLocDefaut.title')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <p class="column is-12 has-text-link">
              {{$t('societes.produitLocDefaut.info')}}
            </p>
            <div class="column is-6">
              <b-field :label="$t('societes.produitLocDefaut.unitaire')">
                <b-select v-model="societe.produitIdDefautUnitaire" expanded>
                  <option></option>
                  <option v-for='produit in listeProduitLoc(societe.produitIdDefautUnitaire)'
                          :key="produit.id"
                          :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.produitLocDefaut.ecranNumerique')">
                <b-select v-model="societe.produitIdDefautEcranNumerique" expanded>
                  <option></option>
                  <option v-for='produit in
                  listeProduitLocNum(societe.produitIdDefautEcranNumerique)'
                          :key="produit.id"
                          :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.produitLocDefaut.regroupement')">
                <b-select v-model="societe.produitIdDefautRegroupement" expanded>
                  <option></option>
                  <option v-for='produit in listeProduitLoc(societe.produitIdDefautRegroupement)'
                          :key="produit.id"
                          :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.produitLocDefaut.regroupementNumerique')">
                <b-select v-model="societe.produitIdDefautRegroupementNumerique" expanded>
                  <option></option>
                  <option v-for='produit in
                  listeProduitLocNum(societe.produitIdDefautRegroupementNumerique)'
                          :key="produit.id"
                          :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.produitLocDefaut.regroupementLc')">
                <b-select v-model="societe.produitIdDefautRegroupementLc" expanded>
                  <option></option>
                  <option v-for='produit in
                  listeProduitLoc(societe.produitIdDefautRegroupementLc)'
                          :key="produit.id"
                          :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{$t('societes.produitAchat.title')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field :label="$t('societes.produitAchat.affichage')">
                <b-select v-model="societe.produitAchatAffichageId" expanded
                          :disabled="societe.produitAchatAffichageId">
                  <option v-for='produit in listeProduitAchat(societe.produitAchatAffichageId)'
                          :key="produit.id"
                          :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.produitAchat.grattage')">
                <b-select v-model="societe.produitAchatGrattageId" expanded
                          :disabled="societe.produitAchatGrattageId">
                  <option v-for='produit in listeProduitAchat(societe.produitAchatGrattageId)'
                          :key="produit.id"
                          :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.produitAchat.laisserEnPlace')">
                <b-select v-model="societe.produitAchatLaisserEnPlaceId" expanded
                  :disabled="societe.produitAchatLaisserEnPlaceId">
                  <option
                    v-for='produit in listeProduitAchat(societe.produitAchatLaisserEnPlaceId )'
                    :key="produit.id"
                    :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.produitAchat.otTech')">
                <b-select v-model="societe.produitAchatTechniqueId" expanded>
                  <option v-for='produit in
                  listeProduitAchatDiversLoc(societe.produitAchatTechniqueId)'
                          :key="produit.id"
                          :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.produitAchat.loyer')">
                <b-select v-model="societe.produitIdDefautLoyer" expanded>
                  <option v-for='produit in listeProduitLocAchat(societe.produitIdDefautLoyer)'
                          :key="produit.id"
                          :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
             <div class="column is-6">
              <b-field :label="$t('societes.produitAchat.reglementTlpe')">
                <b-select v-model="societe.produitReglementTlpeId " expanded>
                  <option v-for='produit in
                    listeProduitAchatDiversLoc(societe.produitReglementTlpeId )'
                          :key="produit.id"
                          :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div v-if="modulePresseActive" class="column is-6">
              <b-field :label="$t('societes.produitAchat.produitAchatCommission')">
                <b-select v-model="societe.produitAchatCommissionId " expanded>
                  <option v-for='produit in
                            listeProduitAchatDiversLoc(societe.ProduitAchatCommissionId )'
                          :key="produit.id"
                          :value="produit.id">
                    {{ produit.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <produit-divers :societe="societe"
                    :produit-divers="produitDivers">
    </produit-divers>
    <produit-associe-loc-defaut :societe="societe"
                                :produits-location="produitsLocation"></produit-associe-loc-defaut>
    <delai-administratif :societe="societe">
    </delai-administratif>

    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('societes.signataire.title')}}
          </p>
        </header>
        <signataire
          :signataire="societe.signataire"
          :emailSignataireRelance.sync="societe.emailSignataireRelance"
          for-societe>
        </signataire>
      </div>
    </div>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{$t('societes.listeAgence')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class=" column is-offset-10 is-2">
              <button  class="button is-primary is-pulled-right"
                  @click="createAgency()">
                {{ $t('societes.createAgence') }}
              </button>
            </div>
            <div class="column is-12">
              <div class="card card-honrizontal "
                :class="{'mgt-20px': $index !== 0}"
                v-for="(agence, $index) in societe.agences" :key="agence.id">
                <div class="columns is-vcentered is-marginless" >
                  <div class="column is-3">
                    <div>
                      <span class="has-text-weight-bold is-size-4 has-text-link link">
                        {{agence.libelle}}
                      </span>
                    </div>
                    <span class="is-italic is-size-7 has-text-secondary-icon">
                      {{agence.codeAgence}}
                    </span>
                  </div>
                  <div class="column is-5">
                    <span class="has-text-default">
                      {{importedFunction.adressFullStringGetter(agence.adresse)}}
                    </span>
                  </div>
                  <div class="column is-3">
                    <span class="has-text-default">
                      {{agence.telephone}}
                    </span>
                  </div>
                  <div class="column is-1">
                    <div class="columns">
                      <div class="column is-6">
                        <div class="has-text-centered">
                          <a @click="editAgence($index)">
                            <b-icon icon="pencil-box-outline" type="is-success"></b-icon>
                          </a>
                        </div>
                      </div>
                      <div class="column is-6">
                        <div class="has-text-centered">
                          <a @click="inProgress()">
                            <b-icon icon="delete-forever" type="is-danger"
                              :class="{
                              'text-access-no-permission' :
                              !checkPermissions(permSocietes.supprimer)}"></b-icon>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('piecesJointes.attachments')}}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes :checkPermissions="true"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/modules/societe-mutation-type';
import { SOCIETES } from '@/configuration/general/permissionsParametrageConf';
import { PRODUIT_ID_LOCATION_PAR_DEFAUT, LISTE_SOCIETES } from '@/configuration/societe/societe';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import inProgress from '@/services/general/inProgress';
import Logo from '@/components/general/Logo';
import Adresse from '@/components/general/adresse';
import PiecesJointes from '@/components/general/piecesJointes';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAll as getAllLocation } from '@/api/produit/produitLocation';
import { getAll as getAllDivers } from '@/api/produit/produitDivers';
import { SENS_ACHAT, SENS_VENTE } from '@/configuration/devisConf';
import produitDivers from '@/components/parametrage/societes/ajoutEditionSociete/produit/m_produitDivers';
import produitAssocieLocDefaut from '@/components/parametrage/societes/ajoutEditionSociete/produit/m_produitAssocieLocDefaut';
import signataire from '@/components/general/signataireAjout';
import delaiAdministratif from '@/components/parametrage/societes/ajoutEditionSociete/m_delaiAdministratif';
import { SOCIETE } from '@/configuration/ville/villeConf';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const societe = createNamespacedHelpers('societe');
const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    societe: Object,
  },
  components: {
    appLogo: Logo,
    appAdresse: Adresse,
    appPiecesJointes: PiecesJointes,
    produitDivers,
    signataire,
    delaiAdministratif,
    produitAssocieLocDefaut,
  },
  data() {
    return {
      SOCIETE: SOCIETE,
      listeSociete: LISTE_SOCIETES,
      importedFunction: {
        adressFullStringGetter,
      },
      permSocietes: SOCIETES,
      produitsLocation: [],
      produitsDiversAchat: [],
      produitsLocationAchat: [],
      produitsLocDiversAchat: [],
      produitDivers: [],
    };
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametreSansFiltreSocieteId: 'parametresWithoutFilterSocieteId',
      parametresInterne: 'parametresInterne',
    }),
    modulePresseActive() {
      return this.parametresInterne([PARAMETRES_INTERNE_KEYS.modulePresse.key]);
    },
  },
  methods: {
    ...societe.mapMutations({
      setSocieteCourante: types.SET_SOCIETE_COURANTE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    listeProduitAchatDiversLoc(id) {
      return this.produitsLocDiversAchat.filter((produitDivers) => {
        return produitDivers.actif || produitDivers.id === id;
      });
    },
    listeProduitAchat(id) {
      return this.produitsDiversAchat.filter((produitDivers) => {
        return produitDivers.actif || produitDivers.id === id;
      });
    },
    listeProduitLoc(id) {
      return this.produitsLocation.filter((produitLoc) => {
        return !produitLoc.numerique && (produitLoc.actif || produitLoc.id === id);
      });
    },
    listeProduitLocAchat(id) {
      return this.produitsLocationAchat.filter((produitLoc) => {
        return !produitLoc.numerique && (produitLoc.actif || produitLoc.id === id);
      });
    },
    listeProduitLocNum(id) {
      return this.produitsLocation.filter((produitLoc) => {
        return produitLoc.numerique && (produitLoc.actif || produitLoc.id === id);
      });
    },
    listeRegimeTva(id) {
      return this.parametreSansFiltreSocieteId(PARAMETRES_KEYS.regimeTva).filter((tva) => {
        return tva.societeId === this.societe.id && (tva.actif || tva.id === id);
      });
    },
    createAgency() {
      this.setSocieteCourante(this.societe);
      this.$router.push({
        name: 'm.parametrage.societe/agence-ajoutAgence',
        params: { societeId: this.societe.id },
      });
    },
    editAgence(indexAgence) {
      this.setSocieteCourante(this.societe);
      this.$router.push({
        name: 'm.parametrage.societe/agence-ajoutAgenceFromSociete',
        params: {
          societeId: this.societe.id,
          indexAgence: indexAgence,
        },
      });
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.regimeTva]);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePresse.key]);
      const queryItemLocation = {
        query: {
          societeId: this.$route.params.id,
          actif: null,
        },
        orderBy: 'ProduitLocation.Quantite, Libelle',
        ascending: true,
        maxResultCount: NO_PAGINATION,
      };
      this.produitsLocation = (await getAllLocation(queryItemLocation)).data.result.items;
      this.produitsLocation.push({
        libelle: this.$t('societes.produitLocDefaut.produitLocationDefaut'),
        id: PRODUIT_ID_LOCATION_PAR_DEFAUT,
        numerique: false,
        actif: true,
      });
      queryItemLocation.query.sens = SENS_ACHAT;
      this.produitsLocationAchat = (await getAllLocation(queryItemLocation)).data.result.items;
      const queryItemDivers = {
        query: {
          societeId: this.$route.params.id,
          sens: SENS_ACHAT,
          actif: null,
        },
        orderBy: 'ProduitDivers.Quantite, Libelle',
        ascending: true,
        maxResultCount: NO_PAGINATION,
      };
      this.produitsDiversAchat = (await getAllDivers(queryItemDivers)).data.result.items;
      this.produitsLocDiversAchat = this.produitsLocationAchat.concat(this.produitsDiversAchat);
      queryItemDivers.query.sens = SENS_VENTE;
      this.produitDivers = (await getAllDivers(queryItemDivers)).data.result.items;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style>

</style>
